import { Destination } from '@/entities/Attractions/domain/Attractions.domain';
import { fetchBlogsByCategory } from './fetchBlogsByCategory';

export const fetchBlogsByDestination = async (destinations: Destination[]) => {
    try {
        const result = await Promise.all(
            destinations.map(async (destination) => {
                const blogs = await fetchBlogsByCategory({ category_id: destination.id });
                return {
                    blogs,
                    destination,
                };
            })
        );

        return result.filter(
            ({ destination, blogs }) => Boolean(destination) && blogs?.items.length
        );
    } catch {
        return [];
    }
};
